import React, { useState } from "react";
import ReusableButton from "../Button";
import { ASSETS } from "../../../utils/config";
import TextView from "../../TextView";
import { colors } from "../../../utils";
import { ViewOne } from "./styles";
import GallerySettings from "../GallerySettings";

const EmptyView = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ViewOne>
        <img
          style={{ margin: "10px auto" }}
          src={ASSETS.segmentEditor.Speaker}
          alt="Image loading"
          width={100}
          height={100}
        />
        <TextView
          variant={"title"}
          style={{
            color: colors.PrimaryPurple,
            textAlign: "center",
            lineHeight: "26px",
          }}
        >
          This is a space to promote your business. Create a business box!
        </TextView>

        <ReusableButton
          customStyles={{
            marginTop: 10,
            backgroundColor: colors.PrimaryPurple,
          }}
          text={"Begin Creating"}
          fullWidth={true}
          onClick={() => setOpen(true)}
        />
      </ViewOne>
    </>
  );
};

export default EmptyView;
